import { createReducer } from "./functions";

import { TYPOLOGIES_SET_LIST } from '../types';

const initialState = {
  typologiesList: [],
  page: 0,
  pages: 0,
  pageSize: 10
}

const setTypologiesList = {
  [TYPOLOGIES_SET_LIST]: (state, action) => {
    const page = action.payload.hasOwnProperty("page")
    ? action.payload.page
    : state.page;
    const pages = action.payload.hasOwnProperty("pages")
      ? action.payload.pages
      : state.pages;
    let hasNext = true;

    if (page === 0 || page === pages)
      hasNext = false;
    return { ...state, typologiesList: action.payload.docs, page, pages, hasNext };
  }
}
const typologiesReducer = createReducer(initialState, {
  ...setTypologiesList
})

export default typologiesReducer;


// WEBPACK FOOTER //
// src/redux/reducers/typologiesReducer.js